import { render, staticRenderFns } from "./creditedDetails.vue?vue&type=template&id=5322a188&scoped=true"
import script from "./creditedDetails.vue?vue&type=script&lang=js"
export * from "./creditedDetails.vue?vue&type=script&lang=js"
import style0 from "./creditedDetails.vue?vue&type=style&index=0&id=5322a188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5322a188",
  null
  
)

export default component.exports